import { StyleSheet } from 'react-native';
import { spacing } from '../../shared/theme/spacing';
import { ticketColors, ticketFonts } from '../../shared/theme/ticketColors';

const sans = { fontFamily: ticketFonts.sans } as const;
const mono = { fontFamily: ticketFonts.mono } as const;

export const kitchenQueueStyles = StyleSheet.create({
  stack: {
    gap: 12,
    alignSelf: 'stretch',
    paddingBottom: spacing.xs,
  },

  /* ── 1. HEADER COMANDO UNIFICADO (IGUAL AL PROTO .kds-top-shell) ── */
  topShellCard: {
    backgroundColor: ticketColors.paper,
    borderRadius: 16,
    borderWidth: 1,
    borderColor: ticketColors.rule,
    paddingHorizontal: 18,
    paddingVertical: 12,
    gap: 10,
  },
  topShellCardMobile: {
    paddingHorizontal: 12,
    paddingVertical: 10,
    gap: 8,
  },
  headerRow: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 12,
    flexWrap: 'wrap',
  },
  titleCluster: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 10,
    flexWrap: 'wrap',
  },
  screenTitle: {
    fontSize: 20,
    lineHeight: 25,
    fontWeight: '800',
    color: ticketColors.ink,
    letterSpacing: -0.3,
    ...sans,
  },
  screenTitleMobile: {
    fontSize: 17,
    lineHeight: 22,
  },
  livePill: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 6,
    paddingHorizontal: 10,
    paddingVertical: 4,
    borderRadius: 999,
    backgroundColor: ticketColors.brandSoft,
    borderWidth: 1,
    borderColor: ticketColors.brandBorderSoft,
  },
  liveDot: {
    width: 7,
    height: 7,
    borderRadius: 999,
    backgroundColor: ticketColors.ok,
  },
  liveDotOffline: {
    backgroundColor: ticketColors.warn,
  },
  livePillText: {
    fontSize: 12,
    fontWeight: '700',
    color: ticketColors.brandInk,
    ...sans,
  },
  controlsCluster: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
    flexWrap: 'wrap',
  },

  /* Segmented group (.seg-group del proto) */
  segGroup: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: ticketColors.counter,
    borderWidth: 1,
    borderColor: ticketColors.rule,
    borderRadius: 10,
    padding: 2,
    gap: 2,
  },
  segBtn: {
    minHeight: 32,
    height: 32,
    paddingHorizontal: 11,
    borderRadius: 8,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 5,
  },
  segBtnActive: {
    backgroundColor: ticketColors.brandPrimary,
  },
  segBtnText: {
    fontSize: 12.5,
    fontWeight: '700',
    color: ticketColors.ink2,
    ...sans,
  },
  segBtnTextActive: {
    color: ticketColors.goldInk,
  },

  /* Botones de acción en el comando (.icon-action-btn del proto) */
  iconActionBtn: {
    minHeight: 36,
    height: 36,
    paddingHorizontal: 12,
    borderRadius: 10,
    borderWidth: 1,
    borderColor: ticketColors.rule,
    backgroundColor: ticketColors.paper,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 6,
  },
  iconActionBtnActive: {
    backgroundColor: ticketColors.brandSoft,
    borderColor: ticketColors.brandBorder,
  },
  iconActionBtnText: {
    fontSize: 12.5,
    fontWeight: '700',
    color: ticketColors.ink,
    ...sans,
  },
  iconActionBtnTextActive: {
    color: ticketColors.brandInk,
  },
  moreBadge: {
    minWidth: 18,
    height: 18,
    paddingHorizontal: 5,
    borderRadius: 99,
    backgroundColor: ticketColors.gold,
    alignItems: 'center',
    justifyContent: 'center',
  },
  moreBadgeText: {
    fontSize: 11,
    fontWeight: '700',
    color: ticketColors.goldInk,
    ...mono,
  },

  /* ── 2. SUB-BARRA: PÍLDORAS DE FILTRO CON CONTADOR + ESTACIONES (.kds-subbar del proto) ── */
  subbarRow: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 10,
    flexWrap: 'wrap',
    paddingTop: 6,
    borderTopWidth: StyleSheet.hairlineWidth,
    borderTopColor: ticketColors.ruleSoft,
  },
  statusTabsScroll: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 6,
  },
  statusTab: {
    minHeight: 36,
    height: 36,
    paddingHorizontal: 11,
    borderRadius: 10,
    borderWidth: 1,
    borderColor: ticketColors.rule,
    backgroundColor: ticketColors.tile,
    flexDirection: 'row',
    alignItems: 'center',
    gap: 7,
  },
  statusTabActive: {
    backgroundColor: ticketColors.brandPrimary,
    borderColor: ticketColors.brandPrimary,
  },
  statusTabLabel: {
    fontSize: 12.5,
    fontWeight: '700',
    color: ticketColors.ink2,
    ...sans,
  },
  statusTabLabelActive: {
    color: ticketColors.goldInk,
  },
  statusTabCountBox: {
    paddingHorizontal: 6,
    paddingVertical: 1,
    borderRadius: 6,
    backgroundColor: 'rgba(28, 25, 23, 0.07)',
  },
  statusTabCountBoxWarn: {
    backgroundColor: ticketColors.warnBg,
    borderWidth: 1,
    borderColor: ticketColors.warnBorder,
  },
  statusTabCountBoxOk: {
    backgroundColor: ticketColors.okBg,
  },
  statusTabCountBoxBad: {
    backgroundColor: 'rgba(185, 28, 28, 0.10)',
  },
  statusTabCountBoxActive: {
    backgroundColor: 'rgba(255, 255, 255, 0.22)',
    borderColor: 'transparent',
  },
  statusTabCountText: {
    fontSize: 12,
    fontWeight: '700',
    color: ticketColors.ink,
    ...mono,
  },
  statusTabCountTextWarn: {
    color: ticketColors.warn,
  },
  statusTabCountTextOk: {
    color: ticketColors.ok,
  },
  statusTabCountTextBad: {
    color: ticketColors.bad,
  },
  statusTabCountTextActive: {
    color: '#FFFFFF',
  },

  /* Estaciones a la derecha de la sub-barra (.station-pills del proto) */
  stationPillsRow: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 5,
    flexWrap: 'wrap',
  },
  stationLbl: {
    fontSize: 11.5,
    fontWeight: '700',
    color: ticketColors.ink3,
    textTransform: 'uppercase',
    letterSpacing: 0.4,
    marginRight: 3,
    ...sans,
  },
  stationChip: {
    minHeight: 30,
    height: 30,
    paddingHorizontal: 10,
    borderRadius: 999,
    borderWidth: 1,
    borderColor: ticketColors.rule,
    backgroundColor: ticketColors.paper,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
  },
  stationChipActive: {
    backgroundColor: ticketColors.ink,
    borderColor: ticketColors.ink,
  },
  stationChipText: {
    fontSize: 12,
    fontWeight: '600',
    color: ticketColors.ink2,
    ...sans,
  },
  stationChipTextActive: {
    color: '#FFFFFF',
    fontWeight: '700',
  },

  /* ── CONTENEDORES DE GRILLA Y COLUMNAS ── */
  listContent: {
    paddingTop: spacing.md,
    paddingBottom: spacing.xl,
    gap: 14,
    paddingHorizontal: spacing.lg,
  },
  listContentKiosk: {
    gap: spacing.md,
  },
  listContentBoard: {
    gap: 14,
  },
  listContentCompact: {
    gap: 10,
    paddingBottom: spacing.lg,
  },
  workspaceRow: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    gap: 16,
  },
  boardColumns: {
    flex: 1,
    minWidth: 0,
    flexDirection: 'row',
    flexWrap: 'wrap',
    alignItems: 'flex-start',
    gap: 14,
  },
  boardColumn: {
    // flexBasis + minWidth: si el ancho reportado es inconsistente (zoom de
    // browser, tablets chicas), las columnas wrappean en vez de aplastarse —
    // una card nunca queda más angosta que ~280px.
    flexGrow: 1,
    flexBasis: 300,
    minWidth: 280,
    maxWidth: 460,
    gap: 14,
  },
  singleColumnCapped: {
    width: '100%',
    maxWidth: 460,
    alignSelf: 'flex-start',
  },

  /* ── ESTADO VACÍO SUPERADOR ("GUARDIA ACTIVA CON VUELTI" — IGUAL AL PROTO .empty-guard-card) ── */
  emptyGuardWrap: {
    width: '100%',
    alignItems: 'center',
    justifyContent: 'center',
    paddingVertical: 20,
    paddingHorizontal: 12,
  },
  emptyGuardCard: {
    width: '100%',
    maxWidth: 580,
    backgroundColor: ticketColors.paper,
    borderWidth: 1,
    borderColor: ticketColors.rule,
    borderRadius: 20,
    paddingHorizontal: 28,
    paddingVertical: 26,
    alignItems: 'center',
    gap: 12,
  },
  vueltiStage: {
    width: 112,
    height: 124,
    borderRadius: 999,
    backgroundColor: ticketColors.brandSoft,
    borderWidth: 1,
    borderColor: ticketColors.brandBorderSoft,
    alignItems: 'center',
    justifyContent: 'center',
  },
  emptyGuardTitle: {
    fontSize: 20,
    lineHeight: 25,
    fontWeight: '800',
    color: ticketColors.ink,
    textAlign: 'center',
    letterSpacing: -0.3,
    ...sans,
  },
  emptyGuardSub: {
    fontSize: 14,
    lineHeight: 21,
    color: ticketColors.ink2,
    textAlign: 'center',
    maxWidth: 420,
    ...sans,
  },
  guardPulseStrip: {
    width: '100%',
    backgroundColor: ticketColors.tile,
    borderWidth: 1,
    borderColor: ticketColors.ruleSoft,
    borderRadius: 12,
    paddingHorizontal: 14,
    paddingVertical: 12,
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 12,
  },
  guardMetric: {
    flex: 1,
    minWidth: 130,
    gap: 2,
  },
  guardMetricLbl: {
    fontSize: 11,
    fontWeight: '700',
    color: ticketColors.ink3,
    textTransform: 'uppercase',
    letterSpacing: 0.4,
    ...sans,
  },
  guardMetricVal: {
    fontSize: 14,
    fontWeight: '700',
    color: ticketColors.ink,
    ...mono,
  },
  emptyActionsRow: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 10,
    flexWrap: 'wrap',
    marginTop: 4,
  },
  btnPrimaryHuman: {
    minHeight: 44,
    height: 44,
    paddingHorizontal: 22,
    borderRadius: 10,
    backgroundColor: ticketColors.brandPrimary,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 8,
  },
  btnPrimaryHumanText: {
    fontSize: 14,
    fontWeight: '800',
    color: '#FFFFFF',
    ...sans,
  },
  btnSecondaryHuman: {
    minHeight: 44,
    height: 44,
    paddingHorizontal: 18,
    borderRadius: 10,
    borderWidth: 1,
    borderColor: ticketColors.rule,
    backgroundColor: ticketColors.paper,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 7,
  },
  btnSecondaryHumanText: {
    fontSize: 13.5,
    fontWeight: '700',
    color: ticketColors.ink,
    ...sans,
  },

  /* ── TARJETA DE COMANDA SUPERADORA (1:1 CON EL PROTO .kds-ticket) ── */
  ticketCard: {
    padding: 0,
    overflow: 'hidden',
    borderRadius: 16,
    borderWidth: 1,
    borderColor: ticketColors.rule,
    backgroundColor: ticketColors.paper,
    gap: 0,
  },
  ticketCardRecent: {
    opacity: 0.88,
  },
  ticketCardFlash: {
    backgroundColor: ticketColors.brandSoft,
    borderColor: ticketColors.gold,
  },
  ticketCardKiosk: {
    minHeight: 140,
  },
  ticketCardCompact: {
    borderRadius: 12,
  },
  ticketCardBoard: {
    width: '100%',
    maxWidth: '100%',
    alignSelf: 'stretch',
  },
  ticketTopBar: {
    height: 5,
    width: '100%',
    backgroundColor: ticketColors.brandPrimary,
  },
  ticketTopBarWarn: {
    backgroundColor: ticketColors.warn,
  },
  ticketTopBarDanger: {
    backgroundColor: ticketColors.bad,
  },
  ticketTopBarReady: {
    backgroundColor: ticketColors.ok,
  },
  ticketHeaderBlock: {
    paddingHorizontal: 14,
    paddingTop: 12,
    paddingBottom: 10,
    backgroundColor: ticketColors.tile,
    borderBottomWidth: 1,
    borderBottomColor: ticketColors.ruleSoft,
    gap: 8,
  },
  ticketHeaderBlockDanger: {
    backgroundColor: 'rgba(185, 28, 28, 0.04)',
  },
  ticketHeaderBlockWarn: {
    backgroundColor: 'rgba(180, 83, 9, 0.05)',
  },
  ticketHeaderBlockReady: {
    backgroundColor: 'rgba(21, 128, 61, 0.05)',
  },
  ticketHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    gap: 8,
  },
  ticketRefGroup: {
    flexDirection: 'row',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: 8,
    flex: 1,
    minWidth: 0,
  },
  ticketId: {
    fontSize: 21,
    lineHeight: 24,
    color: ticketColors.ink,
    fontWeight: '700',
    letterSpacing: -0.5,
    ...mono,
  },
  /* Destino primario al lado de #Ref (.ticket-dest-primary del proto) */
  ticketDestPrimary: {
    paddingHorizontal: 9,
    paddingVertical: 3,
    borderRadius: 7,
    backgroundColor: ticketColors.brandSoft,
    borderWidth: 1,
    borderColor: ticketColors.brandBorderSoft,
  },
  ticketDestDelivery: {
    backgroundColor: '#EFF6FF',
    borderColor: 'rgba(30, 64, 175, 0.20)',
  },
  ticketDestPickup: {
    backgroundColor: ticketColors.counter,
    borderColor: ticketColors.rule,
  },
  ticketDestPrimaryText: {
    fontSize: 13.5,
    fontWeight: '800',
    color: ticketColors.brandInk,
    ...sans,
  },
  ticketDestDeliveryText: {
    color: '#1E40AF',
  },
  ticketDestPickupText: {
    color: ticketColors.ink,
  },

  /* Timer / SLA apilado a la derecha (.ticket-timer-box del proto) */
  ticketTimerBox: {
    alignItems: 'flex-end',
    gap: 2,
    flexShrink: 0,
  },
  timerPill: {
    paddingHorizontal: 8,
    paddingVertical: 3,
    borderRadius: 7,
    backgroundColor: ticketColors.paper,
    borderWidth: 1,
    borderColor: ticketColors.rule,
    flexDirection: 'row',
    alignItems: 'center',
    gap: 5,
  },
  timerPillWarn: {
    backgroundColor: ticketColors.warnBg,
    borderColor: ticketColors.warnBorder,
  },
  timerPillDanger: {
    backgroundColor: ticketColors.bad,
    borderColor: ticketColors.bad,
  },
  timerPillReady: {
    backgroundColor: ticketColors.okBg,
    borderColor: ticketColors.okBorder,
  },
  waitLabel: {
    fontSize: 12.5,
    color: ticketColors.ink,
    fontWeight: '700',
    ...mono,
  },
  waitLabelWarn: {
    color: ticketColors.warn,
  },
  waitLabelDanger: {
    color: '#FFFFFF',
  },
  waitLabelReady: {
    color: ticketColors.ok,
  },
  slaSubRow: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 6,
  },
  slaLabel: {
    fontSize: 11.5,
    color: ticketColors.ink3,
    fontWeight: '600',
    ...sans,
  },
  slaLabelSoon: {
    color: ticketColors.warn,
    fontWeight: '700',
  },
  slaLabelLate: {
    color: ticketColors.bad,
    fontWeight: '700',
  },
  ticketStatus: {
    fontSize: 11.5,
    color: ticketColors.brandPrimary,
    fontWeight: '700',
    ...sans,
  },
  ticketStatusReady: {
    color: ticketColors.ok,
  },

  /* Segunda fila del cabezal (.ticket-head-meta del proto) */
  ticketMetaSubRow: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 8,
    flexWrap: 'wrap',
  },
  badgeRow: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 5,
    flexWrap: 'wrap',
    flex: 1,
  },
  sourceBadge: {
    paddingHorizontal: 7,
    paddingVertical: 2,
    borderRadius: 5,
    backgroundColor: ticketColors.paper,
    borderWidth: 1,
    borderColor: ticketColors.rule,
  },
  sourcePos: {
    backgroundColor: ticketColors.paper,
  },
  sourceOnline: {
    backgroundColor: ticketColors.paper,
  },
  sourceBadgeLabel: {
    fontSize: 11.5,
    color: ticketColors.ink2,
    fontWeight: '700',
    ...sans,
  },
  holdBadge: {
    paddingHorizontal: 7,
    paddingVertical: 2,
    borderRadius: 5,
    backgroundColor: ticketColors.warn,
  },
  holdBadgeLabel: {
    fontSize: 11.5,
    color: '#FFFFFF',
    fontWeight: '700',
    ...sans,
  },
  allDayBadge: {
    paddingHorizontal: 7,
    paddingVertical: 2,
    borderRadius: 5,
    backgroundColor: ticketColors.gold,
  },
  allDayBadgeLabel: {
    fontSize: 11.5,
    color: ticketColors.goldInk,
    fontWeight: '700',
    ...sans,
  },
  rushBadge: {
    paddingHorizontal: 7,
    paddingVertical: 2,
    borderRadius: 5,
    backgroundColor: ticketColors.bad,
  },
  rushBadgeLabel: {
    fontSize: 11.5,
    color: '#FFFFFF',
    fontWeight: '800',
    ...sans,
  },
  unpaidBadge: {
    paddingHorizontal: 7,
    paddingVertical: 2,
    borderRadius: 5,
    backgroundColor: ticketColors.warnBg,
    borderWidth: 1,
    borderColor: ticketColors.warn,
    borderStyle: 'dashed',
  },
  unpaidBadgeStale: {
    backgroundColor: ticketColors.bad,
    borderColor: ticketColors.bad,
    borderStyle: 'solid',
  },
  unpaidBadgeLabel: {
    fontSize: 11.5,
    color: ticketColors.warn,
    fontWeight: '800',
    ...sans,
  },
  unpaidBadgeLabelStale: {
    color: '#FFFFFF',
  },
  customerLine: {
    fontSize: 12,
    color: ticketColors.ink,
    fontWeight: '700',
    ...sans,
  },
  miniLink: {
    fontSize: 12,
    fontWeight: '700',
    color: ticketColors.brandPrimary,
    ...sans,
  },

  /* Puntos de progreso (.ticket-progress-pill + .progress-dots del proto) */
  progressPill: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 6,
  },
  progressDotsRow: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 3,
  },
  progressDot: {
    width: 10,
    height: 5,
    borderRadius: 3,
    backgroundColor: 'rgba(28, 25, 23, 0.14)',
  },
  progressDotDone: {
    backgroundColor: ticketColors.ok,
  },
  progressText: {
    fontSize: 11.5,
    fontWeight: '700',
    color: ticketColors.ink2,
    ...mono,
  },

  /* Nota general del pedido (.ticket-order-note del proto) */
  ticketOrderNote: {
    marginHorizontal: 14,
    marginTop: 10,
    paddingHorizontal: 10,
    paddingVertical: 8,
    borderRadius: 8,
    backgroundColor: ticketColors.warnBg,
    borderWidth: 1,
    borderColor: ticketColors.warnBorder,
    flexDirection: 'row',
    alignItems: 'flex-start',
    gap: 7,
  },
  ticketOrderNoteTag: {
    fontSize: 10.5,
    fontWeight: '800',
    textTransform: 'uppercase',
    letterSpacing: 0.4,
    color: ticketColors.warn,
    backgroundColor: 'rgba(180, 83, 9, 0.12)',
    paddingHorizontal: 5,
    paddingVertical: 1,
    borderRadius: 4,
    overflow: 'hidden',
    ...sans,
  },
  ticketNotes: {
    flex: 1,
    fontSize: 12.5,
    fontWeight: '600',
    color: ticketColors.ink,
    ...sans,
  },

  /* ── CUERPO DE ÍTEMS DE LA COMANDA (1:1 CON EL PROTO .kds-line + .line-check) ── */
  linesBlock: {
    paddingHorizontal: 12,
    paddingVertical: 10,
    gap: 6,
  },
  comboGroup: {
    borderRadius: 10,
    borderWidth: 1,
    borderColor: ticketColors.rule,
    backgroundColor: ticketColors.tile,
    overflow: 'hidden',
  },
  comboGroupHeaderRow: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingHorizontal: 10,
    paddingVertical: 7,
    backgroundColor: 'rgba(28, 25, 23, 0.03)',
    borderBottomWidth: 1,
    borderBottomColor: ticketColors.ruleSoft,
  },
  comboGroupHeader: {
    fontSize: 12.5,
    fontWeight: '800',
    color: ticketColors.ink,
    ...sans,
  },
  comboGroupTag: {
    fontSize: 11,
    fontWeight: '700',
    textTransform: 'uppercase',
    letterSpacing: 0.4,
    color: ticketColors.brandInk,
    backgroundColor: ticketColors.brandSoft,
    paddingHorizontal: 6,
    paddingVertical: 1,
    borderRadius: 4,
    overflow: 'hidden',
    ...sans,
  },
  lineRow: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    gap: 10,
    paddingHorizontal: 10,
    paddingVertical: 9,
    borderRadius: 9,
    borderWidth: 1,
    borderColor: ticketColors.ruleSoft,
    backgroundColor: ticketColors.paper,
    minHeight: 44,
  },
  lineRowComboComponent: {
    borderWidth: 0,
    borderBottomWidth: StyleSheet.hairlineWidth,
    borderBottomColor: ticketColors.ruleSoft,
    borderRadius: 0,
  },
  lineRowCompact: {
    minHeight: 38,
    paddingVertical: 6,
  },
  lineRowDone: {
    backgroundColor: ticketColors.tile,
    opacity: 0.68,
  },
  /* "+N ítems de otras estaciones" — contexto al filtrar una estación por línea */
  lineStationHiddenNote: {
    fontSize: 11.5,
    fontWeight: '600',
    color: ticketColors.ink3,
    paddingHorizontal: 14,
    paddingBottom: 10,
    paddingTop: 2,
    ...sans,
  },
  /* Checkbox táctil cuadrado a la izquierda (.line-check del proto) */
  lineCheckBox: {
    width: 24,
    height: 24,
    borderRadius: 7,
    borderWidth: 2,
    borderColor: ticketColors.rule,
    backgroundColor: ticketColors.paper,
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: 1,
    flexShrink: 0,
  },
  lineCheckBoxDone: {
    backgroundColor: ticketColors.ok,
    borderColor: ticketColors.ok,
  },
  lineMainTapArea: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'flex-start',
    gap: 10,
    minWidth: 0,
  },
  lineQty: {
    fontSize: 16,
    fontWeight: '700',
    color: ticketColors.ink,
    minWidth: 28,
    lineHeight: 21,
    ...mono,
  },
  lineQtyDone: {
    color: ticketColors.ink3,
    textDecorationLine: 'line-through',
  },
  lineBody: {
    flex: 1,
    minWidth: 0,
    gap: 4,
  },
  lineNameRow: {
    flexDirection: 'row',
    alignItems: 'baseline',
    justifyContent: 'space-between',
    gap: 6,
  },
  lineName: {
    fontSize: 14.5,
    lineHeight: 19,
    fontWeight: '700',
    color: ticketColors.ink,
    flex: 1,
    ...sans,
  },
  lineNameDone: {
    color: ticketColors.ink3,
    textDecorationLine: 'line-through',
  },
  lineStationBadge: {
    fontSize: 11,
    fontWeight: '700',
    color: ticketColors.ink3,
    backgroundColor: ticketColors.tile,
    borderWidth: 1,
    borderColor: ticketColors.ruleSoft,
    paddingHorizontal: 6,
    paddingVertical: 1,
    borderRadius: 4,
    overflow: 'hidden',
    ...sans,
  },
  lineComboName: {
    fontSize: 12,
    color: ticketColors.ink2,
    fontStyle: 'italic',
    ...sans,
  },
  modifierRow: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 4,
  },
  modifierChip: {
    paddingHorizontal: 7,
    paddingVertical: 2,
    borderRadius: 5,
    backgroundColor: ticketColors.counter,
  },
  modifierChipExtra: {
    backgroundColor: ticketColors.brandSoft,
    borderWidth: 1,
    borderColor: ticketColors.brandBorderSoft,
  },
  modifierChipExclude: {
    backgroundColor: ticketColors.warnBg,
    borderWidth: 1,
    borderColor: ticketColors.warnBorder,
  },
  modifierChipAllergen: {
    backgroundColor: ticketColors.bad,
  },
  modifierChipLabel: {
    fontSize: 11.5,
    color: ticketColors.ink2,
    fontWeight: '700',
    ...sans,
  },
  modifierChipLabelExtra: {
    color: ticketColors.brandInk,
  },
  modifierChipLabelExclude: {
    color: ticketColors.warn,
  },
  modifierChipLabelAllergen: {
    color: '#FFFFFF',
  },
  kitchenNote: {
    paddingHorizontal: 7,
    paddingVertical: 3,
    borderRadius: 5,
    borderLeftWidth: 2,
    borderLeftColor: ticketColors.warn,
    backgroundColor: ticketColors.warnBg,
  },
  kitchenNoteText: {
    fontSize: 12,
    color: ticketColors.warn,
    fontWeight: '600',
    ...sans,
  },
  /* Botón discreto a la derecha de la línea (.line-86-btn del proto) */
  noHayBtn: {
    paddingHorizontal: 6,
    paddingVertical: 3,
    borderRadius: 6,
    borderWidth: 1,
    borderColor: 'transparent',
    backgroundColor: 'transparent',
    justifyContent: 'center',
    alignItems: 'center',
    flexShrink: 0,
  },
  noHayLabel: {
    fontSize: 11.5,
    color: ticketColors.ink3,
    fontWeight: '700',
    ...sans,
  },

  /* ── PIE DE ACCIONES DE LA COMANDA (1:1 CON EL PROTO .ticket-foot) ── */
  actionsRow: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
    paddingHorizontal: 12,
    paddingTop: 10,
    paddingBottom: 12,
    borderTopWidth: 1,
    borderTopColor: ticketColors.ruleSoft,
    backgroundColor: ticketColors.paper,
  },
  /* Botones cuadrados de ícono (40x42px: Imprimir, Hold/Pausa, Cancelar X) */
  footIconBtn: {
    width: 40,
    height: 42,
    borderRadius: 10,
    borderWidth: 1,
    borderColor: ticketColors.rule,
    backgroundColor: ticketColors.tile,
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
  },
  /* Botón En espera / Soltar con ícono + etiqueta clara en el pie */
  footHoldBtn: {
    height: 42,
    minHeight: 42,
    paddingHorizontal: 11,
    borderRadius: 10,
    borderWidth: 1,
    borderColor: ticketColors.warnBorder,
    backgroundColor: ticketColors.warnBg,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 5,
    flexShrink: 0,
  },
  footHoldBtnActive: {
    backgroundColor: ticketColors.warn,
    borderColor: ticketColors.warn,
  },
  footHoldBtnLabel: {
    fontSize: 12.5,
    fontWeight: '700',
    color: ticketColors.warn,
    ...sans,
  },
  footHoldBtnLabelActive: {
    color: '#FFFFFF',
  },
  footIconBtnDanger: {
    borderColor: ticketColors.rule,
    backgroundColor: ticketColors.tile,
  },
  /* Botón CTA Primario ancho (.foot-primary-cta del proto) */
  footPrimaryCta: {
    flex: 1,
    minHeight: 42,
    height: 42,
    borderRadius: 10,
    backgroundColor: ticketColors.brandPrimary,
    paddingHorizontal: 14,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 8,
  },
  footPrimaryCtaReady: {
    backgroundColor: ticketColors.ok,
  },
  footPrimaryCtaExpo: {
    backgroundColor: ticketColors.ink,
  },
  actionDisabled: {
    opacity: 0.5,
  },
  footPrimaryCtaLabel: {
    fontSize: 14,
    fontWeight: '800',
    color: '#FFFFFF',
    ...sans,
  },
  kbdHintBox: {
    paddingHorizontal: 6,
    paddingVertical: 2,
    borderRadius: 5,
    backgroundColor: 'rgba(0, 0, 0, 0.22)',
  },
  kbdHintText: {
    fontSize: 11.5,
    fontWeight: '600',
    color: '#FFFFFF',
    ...mono,
  },

  /* ── VISTA C: MATRIZ DE PRODUCCIÓN POR ESTACIÓN / PRODUCTO + RAIL LATERAL ── */
  productionSectionWrap: {
    gap: 16,
  },
  stationMatrixGrid: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 14,
    alignItems: 'flex-start',
  },
  stationBatchCard: {
    flexGrow: 1,
    flexBasis: 310,
    maxWidth: 520,
    padding: 0,
    overflow: 'hidden',
    borderRadius: 16,
    borderWidth: 1,
    borderColor: ticketColors.rule,
    backgroundColor: ticketColors.paper,
  },
  stationBatchCardFull: {
    maxWidth: '100%',
    flexBasis: '100%',
  },
  stationBatchHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingHorizontal: 16,
    paddingVertical: 12,
    backgroundColor: ticketColors.ink,
    gap: 8,
  },
  stationBatchTitle: {
    fontSize: 15,
    fontWeight: '800',
    color: '#FFFFFF',
    ...sans,
  },
  stationBatchCountBadge: {
    paddingHorizontal: 8,
    paddingVertical: 2,
    borderRadius: 6,
    backgroundColor: 'rgba(255, 255, 255, 0.16)',
  },
  stationBatchCountText: {
    fontSize: 12,
    fontWeight: '700',
    color: '#FFFFFF',
    ...mono,
  },
  stationBatchBody: {
    paddingHorizontal: 14,
    paddingVertical: 10,
    gap: 8,
  },
  batchItemRow: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 12,
    paddingHorizontal: 12,
    paddingVertical: 10,
    borderRadius: 10,
    borderWidth: 1,
    borderColor: ticketColors.ruleSoft,
    backgroundColor: ticketColors.tile,
    minHeight: 48,
  },
  batchQtyBadge: {
    minWidth: 42,
    height: 34,
    paddingHorizontal: 6,
    borderRadius: 8,
    backgroundColor: ticketColors.brandSoft,
    borderWidth: 1,
    borderColor: ticketColors.brandBorderSoft,
    alignItems: 'center',
    justifyContent: 'center',
  },
  batchQtyText: {
    fontSize: 17,
    fontWeight: '800',
    color: ticketColors.brandInk,
    ...mono,
  },
  batchItemContent: {
    flex: 1,
    minWidth: 0,
    gap: 3,
  },
  batchItemName: {
    fontSize: 14.5,
    fontWeight: '800',
    color: ticketColors.ink,
    ...sans,
  },
  batchItemOptions: {
    fontSize: 12.5,
    color: ticketColors.ink2,
    ...sans,
  },
  batchRefsRow: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 4,
    marginTop: 2,
  },
  batchRefPill: {
    paddingHorizontal: 6,
    paddingVertical: 2,
    borderRadius: 5,
    backgroundColor: ticketColors.paper,
    borderWidth: 1,
    borderColor: ticketColors.rule,
  },
  batchRefPillText: {
    fontSize: 11.5,
    fontWeight: '700',
    color: ticketColors.ink2,
    ...mono,
  },
  stationBatchEmpty: {
    fontSize: 13,
    color: ticketColors.ink3,
    paddingVertical: 14,
    textAlign: 'center',
    ...sans,
  },
  linkedTicketsHeading: {
    fontSize: 14,
    fontWeight: '800',
    color: ticketColors.ink,
    marginTop: 4,
    ...sans,
  },

  /* Rail lateral en Desktop (.allday-rail del proto) */
  sideRailCard: {
    width: 300,
    flexShrink: 0,
    padding: 0,
    overflow: 'hidden',
    borderRadius: 16,
    borderWidth: 1,
    borderColor: ticketColors.rule,
    backgroundColor: ticketColors.paper,
  },
  sideRailHeader: {
    paddingHorizontal: 14,
    paddingVertical: 12,
    backgroundColor: ticketColors.tile,
    borderBottomWidth: 1,
    borderBottomColor: ticketColors.ruleSoft,
    gap: 2,
  },
  sideRailTitleRow: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 6,
  },
  sideRailTitle: {
    fontSize: 13.5,
    fontWeight: '800',
    color: ticketColors.ink,
    ...sans,
  },
  sideRailSub: {
    fontSize: 12,
    color: ticketColors.ink3,
    fontWeight: '600',
    ...sans,
  },
  sideRailBody: {
    paddingHorizontal: 12,
    paddingVertical: 8,
    gap: 6,
  },

  /* ── MODAL DE IMPRESORA / ESTACIONES: chrome lo da ModalShell; acá solo las filas de settings ── */
  settingRowCard: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 12,
    paddingHorizontal: 14,
    paddingVertical: 12,
    borderRadius: 10,
    borderWidth: 1,
    borderColor: ticketColors.ruleSoft,
    backgroundColor: ticketColors.tile,
  },
  settingInfoCol: {
    flex: 1,
    minWidth: 0,
    gap: 2,
  },
  settingInfoTitle: {
    fontSize: 13.5,
    fontWeight: '700',
    color: ticketColors.ink,
    ...sans,
  },
  settingInfoSub: {
    fontSize: 12,
    lineHeight: 16,
    color: ticketColors.ink2,
    ...sans,
  },
  togglePillBtn: {
    minHeight: 32,
    paddingHorizontal: 13,
    paddingVertical: 6,
    borderRadius: 999,
    borderWidth: 1,
    borderColor: ticketColors.rule,
    backgroundColor: ticketColors.paper,
    alignItems: 'center',
    justifyContent: 'center',
  },
  togglePillBtnOn: {
    backgroundColor: ticketColors.brandPrimary,
    borderColor: ticketColors.brandPrimary,
  },
  togglePillText: {
    fontSize: 12,
    fontWeight: '700',
    color: ticketColors.ink,
    ...sans,
  },
  togglePillTextOn: {
    color: '#FFFFFF',
  },

  /* Admin Panels & Reports */
  adminPanel: {
    gap: spacing.sm,
  },
  adminPanelIntro: {
    fontSize: 13,
    lineHeight: 18,
    color: ticketColors.ink2,
    ...sans,
  },
  stationCard: {
    gap: spacing.xs,
    padding: spacing.sm,
    borderRadius: 12,
    borderWidth: 1,
    borderColor: ticketColors.ruleSoft,
    backgroundColor: ticketColors.tile,
  },
  stationMeta: {
    fontSize: 12,
    lineHeight: 16,
    color: ticketColors.ink2,
    ...sans,
  },
  stationActionsRow: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: spacing.xs,
    flexWrap: 'wrap',
  },
  stationInlinePanel: {
    marginTop: spacing.xs,
    gap: spacing.xs,
  },
  stationEditRow: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: spacing.xs,
    flexWrap: 'wrap',
  },
  stationNameText: {
    fontSize: 15,
    lineHeight: 20,
    color: ticketColors.ink,
    fontWeight: '600',
    flex: 1,
    ...sans,
  },
  stationInput: {
    flex: 1,
    borderWidth: 1,
    borderColor: ticketColors.ruleSoft,
    borderRadius: 10,
    paddingHorizontal: spacing.sm,
    paddingVertical: 8,
    color: ticketColors.ink,
    backgroundColor: ticketColors.tile,
    fontSize: 15,
    ...sans,
    minHeight: 44,
  },
  stationActionBtn: {
    paddingHorizontal: spacing.sm,
    paddingVertical: 8,
    borderRadius: 10,
    borderWidth: 1,
    borderColor: ticketColors.ruleSoft,
    backgroundColor: ticketColors.tile,
    minHeight: 42,
    justifyContent: 'center',
  },
  stationSaveBtn: {
    borderColor: ticketColors.gold,
    backgroundColor: ticketColors.gold,
  },
  stationDeleteBtn: {
    borderColor: ticketColors.bad,
  },
  stationAddBtn: {
    borderColor: ticketColors.gold,
    alignSelf: 'flex-start',
  },
  stationActionLabel: {
    fontSize: 13,
    color: ticketColors.ink,
    fontWeight: '600',
    ...sans,
  },
  stationActionLabelPrimary: {
    fontSize: 13,
    color: ticketColors.goldInk,
    fontWeight: '600',
    ...sans,
  },
  stationActionLabelDanger: {
    fontSize: 13,
    color: ticketColors.bad,
    fontWeight: '600',
    ...sans,
  },
  stationActionLabelAccent: {
    fontSize: 13,
    color: ticketColors.gold,
    fontWeight: '600',
    ...sans,
  },
  productAssignPanel: {
    marginTop: spacing.sm,
    gap: spacing.xs,
  },
  productAssignHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: spacing.xs,
  },
  productAssignTitle: {
    fontSize: 15,
    color: ticketColors.ink,
    fontWeight: '700',
    ...sans,
  },
  productListScroll: {
    maxHeight: 300,
  },
  productRow: {
    paddingVertical: 10,
    paddingHorizontal: spacing.sm,
    borderRadius: 10,
    borderWidth: 1,
    borderColor: ticketColors.ruleSoft,
    marginBottom: 4,
    backgroundColor: ticketColors.tile,
    minHeight: 44,
    justifyContent: 'center',
  },
  productRowActive: {
    borderColor: ticketColors.gold,
    backgroundColor: ticketColors.brandSoft,
  },
  productRowLabel: {
    fontSize: 15,
    color: ticketColors.ink,
    ...sans,
  },
  productRowLabelActive: {
    color: ticketColors.brandInk,
    fontWeight: '600',
  },
  noProductsText: {
    fontSize: 13,
    color: ticketColors.ink2,
    paddingVertical: spacing.sm,
    ...sans,
  },
  reportTitle: {
    fontSize: 17,
    color: ticketColors.ink,
    fontWeight: '700',
    marginBottom: spacing.sm,
    ...sans,
  },
  reportStats: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: spacing.md,
  },
  reportStat: {
    flex: 1,
    minWidth: 90,
    alignItems: 'center',
  },
  reportStatValue: {
    fontSize: 22,
    color: ticketColors.gold,
    fontWeight: '800',
    ...mono,
  },
  reportStatLabel: {
    fontSize: 12.5,
    color: ticketColors.ink2,
    textAlign: 'center',
    ...sans,
  },
  reportEmpty: {
    fontSize: 15,
    color: ticketColors.ink2,
    ...sans,
  },
});
